import { render, staticRenderFns } from "./projectDetailsTable.vue?vue&type=template&id=7af8d6bc"
import script from "./projectDetailsTable.vue?vue&type=script&lang=js"
export * from "./projectDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./projectDetailsTable.vue?vue&type=style&index=0&id=7af8d6bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports